import { HttpService } from 'services/http';


export const fetchCountriesAPI = () => HttpService.get('/v2/countries');


export default { fetchCountriesAPI };
